import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import * as moment from 'moment';

@Component({
  selector: 'app-alert-invalid-rubric-slot',
  templateUrl: './alert-invalid-rubric-slot.component.html',
  styleUrls: ['./alert-invalid-rubric-slot.component.css']
})
export class AlertInvalidRubricSlotComponent implements OnInit {

  orderHour: string = moment(this.tools.getStor("hour_order")).format("HH:mm");
  errRub: any;
  currPoint:any = this.tools.getStor("point_of_sale");
  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<AlertInvalidRubricSlotComponent>,
    private tools: ToolsService
  ) {
    this.errRub = data.errRub;
  }

  ngOnInit() {
  }

  closeDial() {
    this.dialogRef.close();
  }

}
